export const transcludeWithComponentModule = angular
  .module('Q.components.transclude-with', [])

  /**
   * @name TranscludeWith
   * @docType shared
   * @category directive
   * @description
   * Allows a directive to pass items back into a transcluded scope.
   *
   * Mainly useful for a directive that wants to use an ng-repeat, but allow the caller to define some or
   * all of the ng-repeat's contents
   *
   * Usage:
   *
   * <pre><code>
   * &lt;ANY transclude-with="..."> or &lt;transclude-with scope="...">
   * </code></pre>
   *
   * The value of scope should be a hash, where the properties will be mapped { fromScope: toScope }
   *
   * So, for example, if a directive has this format:
   *
   * <pre><code>
   *   &lt;transclude-with scope="{ item: 'foo' }">
   * </code></pre>
   *
   * then the transcluded content of the directive will have access to a property called `foo`, which is
   * the value of scope.foo from inside the directive.
   *
   * Example:
   *
   * <pre><code>
   * &lt;li ng-repeat="item in ctrl.items">
   *     &lt;transclude-with scope="{ item: ctrl.repeatItemName }">&lt;/transclude-with>
   * &lt;/li>
   * </code></pre>
   * @returns Directive Definition Object {object}
   */
  .directive('transcludeWith', function () {
    return {
      restrict: 'AE',
      link: function (scope, elem, attrs, ctrl, transclude) {
        let transcludedScopeProperties = attrs.transcludeWith || attrs.scope;

        if (!transcludedScopeProperties) {
          throw new Error(
            'No transcluded scope properties found for transclude-with',
          );
        }
        if (!transclude) {
          throw new Error('No transclude function for transclude-with');
        }

        // parse the inline object
        transcludedScopeProperties = scope.$eval(transcludedScopeProperties);

        transclude(
          function (clone, tScope) {
            // duplicates ng-transclude core functionality
            elem.empty();
            elem.append(clone);

            // now add in the directive's scope properties
            angular.forEach(
              transcludedScopeProperties,
              function (tScopeName, scopeName) {
                let watch = tScopeName[0] === '=';
                if (watch) {
                  tScopeName = tScopeName.slice(1);
                  scope.$watch(
                    scopeName,
                    () => (tScope[tScopeName] = scope[scopeName]),
                  );
                }
                tScope[tScopeName] = scope[scopeName];
              },
            );
          },
          null,
          attrs.transcludeSlot,
        );
      },
    };
  });
